import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';
import store from '@/store';
import { getDistricts } from '@/api/districts';
import { IDistrict } from '@/api/districts';
import { IAsyncState } from '@/utils/types';
import { errorHandler } from '@/utils/common';

export interface IMapState {
  districts: IAsyncState<IDistrict[]>;
}

@Module({ dynamic: true, store, name: 'map' })
class Map extends VuexModule implements IMapState {
  districts: IAsyncState<IDistrict[]> = {
    entity: [],
    loading: false,
    loaded: false,
  };

  @Mutation
  pendingLoadDistricts() {
    this.districts.entity = [];
    this.districts.loading = true;
    this.districts.loaded = false;
  }

  @Mutation
  private fulfilledLoadDistricts(districts: IDistrict[]) {
    this.districts.entity = districts;
    this.districts.loading = false;
    this.districts.loaded = true;
  }

  @Mutation
  private rejectedLoadDistricts(error: unknown) {
    errorHandler(error);
    this.districts.loading = false;
  }

  @Action
  async loadDistricts(regionCode: string) {
    this.pendingLoadDistricts();

    try {
      const districts = await getDistricts({ regionCode });
      this.fulfilledLoadDistricts(districts);
    } catch (error) {
      this.rejectedLoadDistricts(error);
    }
  }
}

export const MapModule = getModule(Map);
